import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { FaCaretLeft, FaCaretRight } from "react-icons/fa";
import { PiInfo } from "react-icons/pi";
import { useNavigate, useParams } from "react-router-dom";
import { NavAndTabs } from "../../../components";
import HealthTracking from "./healthTracking";
import HearingAndSeeing from "./hearingAndSeeing";
import DigestionAndNutrition from "./digestionAndNutrition";
import ChronicDiseasesAndConditions from "./chronicDiseasesAndConditions";
import RecentMedicalHistory from "./recentMedicalHistory";
import MedicationIntake from "./medicationIntake";

const HealthInformation = ({ loginData }) => {
  const { t } = useTranslation();
  const { subId } = useParams();
  const [activeTab, setActiveTab] = useState(subId || "health-tracking");
  const [currentPage, setCurrentPage] = useState(1);

  const navigate = useNavigate();

  const getPageNoFromTab = (tabId) => {
    switch (tabId) {
      case "health-tracking":
        return 1;
      case "hearing-and-seeing":
        return 2;
      case "digestion-and-nutrition":
        return 3;
      case "chronic-diseases-and-conditions":
        return 4;
      case "recent-medical-history":
        return 5;
      case "medication-intake":
        return 6;
      default:
        return 1;
    }
  };

  const pageNoToTabId = {
    1: "health-tracking",
    2: "hearing-and-seeing",
    3: "digestion-and-nutrition",
    4: "chronic-diseases-and-conditions",
    5: "recent-medical-history",
    6: "medication-intake",
  };

  useEffect(() => {
    const page = getPageNoFromTab(subId || "health-tracking");
    setCurrentPage(page);
    setActiveTab(subId || "health-tracking");
  }, [subId]);

  const onTabChange = (tabId) => {
    const page = getPageNoFromTab(tabId);
    setActiveTab(tabId);
    setCurrentPage(page);
    navigate(`/patient/my-profile/health-information/${tabId}`);
  };

  const handlePageChange = (direction) => {
    let newPage = currentPage;
    if (direction === "next" && currentPage < 6) {
      newPage = currentPage + 1;

      // dispatch(
      //   actionPatient.postAnswers(
      //     { answerList: answersData, pageNo: currentPage },
      //     (error, response) => {
      //       if (error) {
      //         console.log("error", error);
      //       } else if (response) {
      //         console.log("response", response);
      //       }
      //     }
      //   )
      // );
    } else if (direction === "prev" && currentPage > 1) {
      newPage = currentPage - 1;
    }

    if (newPage !== currentPage) {
      setCurrentPage(newPage);
      const newTabId = pageNoToTabId[newPage];
      onTabChange(newTabId);
    }
  };
  const tabs = [
    {
      id: "health-tracking",
      label: (
        <>
          1.{" "}
          <span className="nav-link-span">
            {t("patient_Details.health_information.health_tracking")}
          </span>
        </>
      ),
      content: (<HealthTracking
        loginData={loginData}
        activeTab={activeTab}
        tabId="health-tracking"
        currentPage={currentPage} />),
      disabled: false,
    },
    {
      id: "hearing-and-seeing",
      label: (
        <>
          2.{" "}
          <span className="nav-link-span">
            {t("patient_Details.health_information.hearing_and_seeing")}
          </span>
        </>
      ),
      content: (<HearingAndSeeing
        loginData={loginData}
        activeTab={activeTab}
        tabId="hearing-and-seeing" />),
      disabled: false,
    },
    {
      id: "digestion-and-nutrition",
      label: (
        <>
          3.{" "}
          <span className="nav-link-span">
            {t("patient_Details.health_information.digestion_and_nutrition")}
          </span>
        </>
      ),
      content: (<DigestionAndNutrition
        loginData={loginData}
        activeTab={activeTab}
        tabId="digestion-and-nutrition" />),
      disabled: false,
    },
    {
      id: "chronic-diseases-and-conditions",
      label: (
        <>
          4.{" "}
          <span className="nav-link-span">
            {t("patient_Details.health_information.chronic_diseases")}
          </span>
        </>
      ),
      content: (<ChronicDiseasesAndConditions
        loginData={loginData}
        activeTab={activeTab}
        tabId="chronic-diseases-and-conditions"
      />),

      disabled: false,
    },
    {
      id: "recent-medical-history",
      label: (
        <>
          5.{" "}
          <span className="nav-link-span">
            {t("patient_Details.health_information.recent_medical_history")}
          </span>
        </>
      ),
      content: (<RecentMedicalHistory
        loginData={loginData}
        activeTab={activeTab}
        tabId="recent-medical-history"
      />),
      disabled: false,
    },
    {
      id: "medication-intake",
      label: (
        <>
          6.{" "}
          <span className="nav-link-span">
            {t("patient_Details.health_information.medication_intake")}
          </span>
        </>
      ),
      content: (<MedicationIntake
        loginData={loginData}
        activeTab={activeTab}
        tabId="medication-intake"
      />),
      disabled: false,
    },
  ];

  return (
    <Container fluid className="exado-container1">
      <Row className="exado-row1">
        <Col>
          <p className="exado-title-six d-flex align-items-center">
            <div>
              <PiInfo className="ai-piInfo" />
            </div>
            <div>{t("patient_Details.health_information.information")}</div>
          </p>
        </Col>
      </Row>
      <Row className="exado-row1">
        <Col>
          <NavAndTabs.NavAndTabs
            tabs={tabs}
            activeTab={activeTab}
            onTabChange={onTabChange}
            tabClassName="nav-and-tab1"
            contentClassname="nav-and-tab-content1"
          />
        </Col>
      </Row>
      <Row className="exado-row1">
        <Col className="d-flex justify-content-end align-items-center">
          <aside className="table-footer-rside">
            <label htmlFor="" className="table-footer-rside-lable">
              {t("Page")} {currentPage} {t("of")} 6
            </label>
            <div className="Page-icon-blk">
              <FaCaretLeft
                className="Page-icon-left"
                onClick={() => handlePageChange("prev")}
              />
              <FaCaretRight
                className="Page-icon-right"
                onClick={() => handlePageChange("next")}
              />
            </div>
          </aside>
        </Col>
      </Row>
    </Container>
  );
};

export default HealthInformation;
